import React, { useState, useEffect } from 'react';
import { TextStyle, LegacyStack} from '@shopify/polaris';

export default function OrderRow(props) {
  const {name, customer_url, id, cancelled_at, created_at, financial_status, fulfillment_status, total_price, currency} = props.item;

  const total_price_formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(total_price);
  const created_at_formatted = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit'
  }).format(new Date(created_at));

  return (
    <tr className={`order-row`}>
      <td>
        <a href={customer_url}>{name}</a> - {id}
      </td>
      <td><span className="note">{created_at_formatted}</span></td>
      <td><span className={`status_${financial_status}`}>{financial_status}</span></td>
      <td><span className={`status_${fulfillment_status}`}>{cancelled_at ? 'cancelled' : fulfillment_status}</span></td>
      <td><span className="total money">{total_price_formatted}</span></td>
    </tr>
  )
}
